import React from 'react';
import {DESIGNER_WORKFLOWS} from '@packages/systems/designer/workflows';
import {WEBFLOW_SITE_ID_ATTR} from '@packages/systems/core/constants/SharedConfig';
import {LocaleUtils} from '@packages/systems/localization';

/**
 * Hook that manages document attributes and classes based on site and workflow state
 */
export const useDocumentAttributes = (
  siteId: string | undefined,
  workflow: string | undefined,
  isUnauthorizedUserType: boolean | undefined,
  currentLocaleTag: string | undefined,
  isOpenCanvasActive: boolean | undefined,
  isAnonymousCommentUserType?: boolean | undefined
) => {
  React.useEffect(() => {
    // setting current site id in html as it is used in the BaseSiteModules code (js/site/webflow.js), specifically in the logic for forms
    if (siteId) {
      document.documentElement.setAttribute(WEBFLOW_SITE_ID_ATTR, siteId);
    }

    if (isUnauthorizedUserType) {
      document.documentElement.classList.add('wf-read-only');
    }

    if (isAnonymousCommentUserType) {
      document.documentElement.classList.add('wf-anonymous-comment');
    }

    // setting current locale tag in html, so the styles that are set on locals will be applied correctly
    document.documentElement.setAttribute('lang', currentLocaleTag || 'en');
    if (isOpenCanvasActive) {
      document.documentElement.removeAttribute('dir');
    } else if (currentLocaleTag && LocaleUtils.isRTL(currentLocaleTag)) {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.removeAttribute('dir');
    }

    if (workflow === DESIGNER_WORKFLOWS.COMMENT) {
      document.documentElement.classList.add('wf-custom-code-annotations');
      document.documentElement.classList.add('wf-custom-code-binding');
    } else {
      document.documentElement.classList.remove('wf-custom-code-annotations');
      document.documentElement.classList.remove('wf-custom-code-binding');
    }
  }, [
    siteId,
    workflow,
    isUnauthorizedUserType,
    currentLocaleTag,
    isOpenCanvasActive,
  ]);
};
